import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { PartnerService } from '../services/partner.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService, 
                private partnerService: PartnerService, 
                private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const authToken = this.authService.getToken() || '';
        const username = this.authService.getUser()?.username || '';
        const partnerId = this.partnerService.getPartnerId() || '';

        if (authToken && !req.url.includes('google')) {
            const authReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + authToken)
                    .set('x-user-email', username)
                    .set('X-Partner', partnerId)
            });
            return next.handle(authReq).pipe(
                catchError((error: HttpErrorResponse) => {
                    if (!error || error.status === 401) {
                        this.authService.clearToken();
                        this.router.navigateByUrl('/');
                    }
                    return throwError(() => error);
                })
            );
        }

        return next.handle(req);
    }
}
